// src/components/ResetPasswordModal.js
import React, { useEffect, useState } from "react";
import { API_URL } from "../config";

function ResetPasswordModal({ onClose }) {
  const [users, setUsers] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [msg, setMsg]   = useState("");

  // lista użytkowników tylko raz przy otwarciu
  useEffect(() => {
    fetch(`${API_URL}/users`, {
      credentials: "include",
    })
      .then((r) => r.json())
      .then(setUsers)
      .catch(console.error);
  }, []);

  const handleReset = async () => {
    if (!selectedId) return;

    try {
      const res = await fetch(
        `${API_URL}/users/${selectedId}/resetPassword`,
        { method: "POST", credentials: "include" }
      );
      if (!res.ok) throw new Error("Błąd");
      setMsg("✅ E-mail z nowym hasłem został wysłany.");
    } catch (err) {
      console.error(err);
      setMsg("❌ Nie udało się zresetować hasła.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>Zresetuj Hasło Użytkownika</h3>

        <label>Wybierz użytkownika:</label>
        <select
          value={selectedId}
          onChange={(e) => setSelectedId(e.target.value)}
        >
          <option value="">-- wybierz --</option>
          {users.map((u) => (
            <option key={u.id} value={u.id}>
              {u.login} ({u.first_name} {u.last_name})
            </option>
          ))}
        </select>

        <div className="modal-buttons" style={{ marginTop: "1rem" }}>
          <button
            className="btn-submit"
            onClick={handleReset}
            disabled={!selectedId}
          >
            Wyślij nowe hasło
          </button>
          <button className="btn-submit" onClick={onClose}>
            Zamknij
          </button>
        </div>

        {msg && <p style={{ marginTop: "0.6rem" }}>{msg}</p>}
      </div>
    </div>
  );
}

export default ResetPasswordModal;
